import { breakpoints } from '@bnnvara/breakpoints';
import { ThemeIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Theme';
import { Text } from '@bnnvara/typography';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { typography, space } from 'styled-system';

const Small = css`
  div {
    font-size: 14px;
  }
  svg {
    height: 8px;
    width: 8px;
  }
`;

const StyledThemeTagMedia = styled.span`
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  cursor: pointer;

  div {
    color: ${({ color }) => color};
    margin-top: 1px;
    font-size: 10px;
    font-weight: 700;

    ${breakpoints.md} {
      padding: 4px 0px;
      border-radius: 2px;
      color: ${({ color }) => color};
      font-size: 12px;
      font-weight: 700;
      line-height: '12px';
    }
  }
  &:hover {
    div {
      color: ${({ colorHover }) => colorHover};
    }
    svg {
      * {
        fill: ${({ colorHover }) => colorHover};
      }
    }
  }
  &:active {
    div {
      color: ${({ colorActive }) => colorActive};
    }
    svg {
      * {
        fill: ${({ colorActive }) => colorActive};
      }
    }
  }

  ${breakpoints.md} {
    border-radius: 2px;
  }

  svg {
    height: 14px;
    width: 8px;
    padding-right: 4px;
    * {
      fill: ${({ color }) => color};
    }
    ${breakpoints.md} {
      margin-top: 1px;
      height: 20px;
      width: 8px;
    }
  }

  ${({ size }) => size === 'sm' && Small};
  ${space}
  ${typography}
`;

export const ThemeTagMedia = ({ children, size, theme, ...props }) => {
  return (
    <Link href={`/thema/${theme?.slug}`}>
      <StyledThemeTagMedia
        color={theme?.color}
        colorHover={theme?.colorHover}
        colorActive={theme?.colorActive}
        colorVisited={theme?.colorVisited}
        size={size}
        {...props}
      >
        <ThemeIcon />
        <Text>{children}</Text>
      </StyledThemeTagMedia>
    </Link>
  );
};

ThemeTagMedia.defaultProps = {
  size: 'md',
};

ThemeTagMedia.propTypes = {
  children: PropTypes.node.isRequired,
  iconLeft: PropTypes.node,
  theme: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    slug: PropTypes.string,
    color: PropTypes.string,
    colorHover: PropTypes.string,
    colorActive: PropTypes.string,
    colorVisited: PropTypes.string,
  }).isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
};
